module.exports = __webpack_public_path__ + "img/cslogo.98283552.png";